// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.ssh_keys_catalog.SSHKeysCatalog

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { SSHKeyData, SSHKeyStore } from "./SSHKey.generated";

export interface SSHKeysCatalogData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "SSHKeysCatalog";
    keys: Record<string, SSHKeyData>;
}

export class SSHKeysCatalogStore {
    readonly _entity_class_name = "SSHKeysCatalog" as const;
    keys: Record<string, SSHKeyStore>;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: SSHKeysCatalogData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.keys = Object.fromEntries(
            Object.entries(data.keys ?? {}).map(([key, val]) => [
                key, wrapEntity(val, transport, [...chainPath, "keys", key]),
            ])
        ) as Record<string, SSHKeyStore>;
        makeObservable(this, {
            keys: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async get_key_path(name: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "get_key_path", [name], {});
    }

    async add_key(name: any, private_key: any, public_key?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "add_key", [name, private_key, public_key], {});
    }

    async remove_key(name: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "remove_key", [name], {});
    }
}

registerEntity("SSHKeysCatalog", SSHKeysCatalogStore);
